import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCareTeam from '../reducer/care-team.reducer';

const selectCareTeamFeatureUnsafe = createFeatureSelector<fromCareTeam.CareTeamState | undefined>(
  fromCareTeam.careTeamFeatureKey
);

export const selectCareTeamFeature = createSelector(
  selectCareTeamFeatureUnsafe,
  state => state ?? fromCareTeam.initialState
);

const { selectEntities, selectAll } = fromCareTeam.careTeamAdapter.getSelectors();

export const selectCareTeamEntities = createSelector(selectCareTeamFeature, selectEntities);

export const selectCareTeam = createSelector(selectCareTeamFeature, selectAll);

export const selectError = createSelector(selectCareTeamFeature, state => state.baseState.error);

export const selectIsLoading = createSelector(selectCareTeamFeature, state => state.baseState.isLoading);

export const selectCareTeamMemberById = (providerUserId: string) =>
  createSelector(selectCareTeam, entities => {
    const member = entities.find(f => f.providerUserId === providerUserId);
    return member === undefined ? null : member;
  });
